export default {
      id: "app-sync-usage",
      viewBox: "0 0 91 92",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#app-sync",
      toString: function () {
        return this.url;
      }
    }